module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\r\n"